import React, { useContext } from 'react';
import { WizardContext } from "./Wizard";

export default () => {
    return useContext(WizardContext);
};